
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

type ButtonVariant = 'primary' | 'secondary' | 'cancel' | 'transparent'

@Component<Button>({})
export default class Button extends Vue {
    @Prop({ type: String, default: 'primary' }) public variant!: ButtonVariant
    @Prop({ type: Boolean, default: false }) public faded!: boolean
    @Prop({ type: Boolean, default: false }) public noBorder!: boolean

    public get className() {
        return [
            'button',
            this.variant,
            this.faded ? 'faded' : '',
            this.noBorder ? 'no-border' : '',
        ].join(' ')
    }
}
